import React from "react";
import { TextField, Typography } from "@mui/material";
import { QuestionCard } from "../shared/QuestionCard";

type Props = {
  value: string;
  onChange: (email: string) => void;
};

export function OwnerEmailQuestion({ value, onChange }: Props) {
  return (
    <QuestionCard
      title="What's your email?"
      subtitle="We'll send your personalised plan here"
      field="ownerEmail"
    >
      <TextField
        placeholder="example@email.com"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="email"
        inputMode="email"
        type="email"
        fullWidth
        variant="outlined"
        sx={{
          maxWidth: 400,
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#FFFFFF",
            borderRadius: "10px",
            padding: 0,
            "& fieldset": { border: "2px solid #7B3306" },
            "&:hover fieldset": { border: "2px solid #7B3306" },
            "&.Mui-focused fieldset": {
              border: "2px solid #4A90E2",
              boxShadow: "0 0 8px rgba(74,144,226,0.35)",
            },
          },
          "& .MuiInputBase-input": {
            backgroundColor: "#FFFFFF",
            padding: { xs: "16px 14px", sm: "18px 14px" },
            fontWeight: 500,
            fontSize: { xs: "16px", sm: "15px" },
            lineHeight: 1.2,
            color: "#4A3026",
            textAlign: "center",
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A06B4D",
            opacity: 0.7,
          },
        }}
      />

      <Typography
        sx={{
          mt: 2,
          fontSize: { xs: 11, sm: 12 },
          color: "#A06B4D",
          maxWidth: 350,
          mx: "auto",
          lineHeight: 1.4,
        }}
      >
        We'll email you important service updates. Your data is safe with us.
      </Typography>
    </QuestionCard>
  );
}
